import React, { useState, useContext } from "react";
import DataTable from "react-data-table-component";
import PageHeader from "../../components/common/PageHeader";
import { TimeAttandanceData } from "../../components/Data/AppData";
// import { EmployessYearlyStatusData, TodayTimeUtilisationData } from "../../components/Data/ChartData";
import RecentActivityCard from "../../components/Employees/RecentActivityCard";
import StatisticsCard from "../../components/Employees/StatisticsCard";
import GeneralChartCard from "../../components/Employees/TodayTimeUtilisation";
import DropDownService from "../../services/DropDownService";
import useAsync from "../../hooks/useAsync";
import ModalLoading from "../../components/Loading/ModalLoading";
import AttendanceServices from "../../services/AttendanceServices";
import { allContext } from "../../context/AllContext";

function AttendanceEmployees() {


    const [employeeId, setEmployeeId] = useState("");
    const { reportSearch, setReportSearch } = useContext(allContext);
    var { data: data, tableLoading, loading } = useAsync(() => AttendanceServices.getEmployeeAttendanceById({ id: employeeId }));

    const { data: employeeDropdown, loading: dropDownLoading } = useAsync(() => DropDownService.employeeDropDown());

    const TodayTimeUtilisationData = {
        options: {
            chart: {
                height: 250,
                type: 'radialBar',
            },
            colors: ['var(--chart-color1)'],
            plotOptions: {
                radialBar: {
                    hollow: {
                        size: '70%',
                    }
                },
            },
            series: [data?.data?.today?.working || 0],
            labels: ['Working'],
        }
    }

    const EmployessYearlyStatusData = {
        options: {
            chart: {
                height: 350,
                type: 'line',
                toolbar: {
                    show: false,
                },
            },
            colors: ['var(--chart-color1)', 'var(--chart-color2)'],
            series: [{
                name: 'Working Hours',
                type: 'column',
                data: data?.data?.yearlyStatus?.hours || []
            }, {
                name: 'Employees Progress',
                type: 'line',
                data: data?.data?.yearlyStatus?.employeeProgress || []
            }],
            stroke: {
                width: [0, 4]
            },
            labels: data?.data?.yearlyStatus?.years || [],
            yaxis: [{
                title: {
                    text: 'Working Hours',
                },

            }, {
                opposite: true,
                title: {
                    text: 'Employees Progress'
                }
            }]
        }
    }

    const columnST = [
        {
            name: "EMPLOYEE",
            selector: row => row.employeeName,
            sortable: true
        },
        {
            name: "DATE",
            selector: row => row.date,
            sortable: true,
        },
        {
            name: "PUNCHIN",
            selector: (row) => row.punchInTime,
            sortable: true,
        },
        {
            name: "PUNCHOUT",
            selector: (row) => <span className="text-danger">{row.punchOutTime}</span>,
            sortable: true,
        },
        {
            name: "BREAK TIME",
            selector: (row) => <span className="text-danger">{row.breakHours}</span>,
            sortable: true,
        },
        {
            name: "HALF DAY",
            selector: (row) => <i className={` ${row.halfDay === 'No' ? 'icofont-close-circled text-danger' : 'icofont-check-circled text-success'}`}></i>,
            sortable: true
        },
        {
            name: "FULL DAY",
            selector: (row) => <i className={` ${row.fullDay === 'No' ? 'icofont-close-circled text-danger' : 'icofont-check-circled text-success'}`}></i>,
            sortable: true
        },
        {
            name: "OVERTIME",
            selector: (row) => <span className="text-success">{row.overtime}</span>,
            sortable: true,
        },
        {
            name: "TOTAL HOURS",
            selector: (row) => row.totalHours
        }
    ];

    return (
        <div className="container-xxl">
            <PageHeader headerTitle="Attendance Employees" />

            <div className="row">
                <div className="col-lg-12 pb-4 d-flex justify-content-between">
                    <div className=" col-lg-3">
                        <label className="form-label fw-bold">Select Employee</label>
                        <select className="form-select"
                            value={employeeId}
                            onChange={(e) => { setEmployeeId(e.target.value); setReportSearch(!reportSearch) }}
                        >
                            <option value="" defaultValue hidden>--- All Employee ---</option>
                            {!dropDownLoading && employeeDropdown?.data?.map((val, idx) => (
                                <option key={idx} value={val?.value}>{val?.label}</option>
                            ))
                            }
                        </select>
                    </div>
                </div>
            </div>
            {employeeId &&
                <>{loading || tableLoading ? <ModalLoading loading={tableLoading} /> :
                    <>
                        <div className="row align-item-center row-deck g-3 mb-3">
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-12">
                                <GeneralChartCard Title="Today Time Utilisation" extraDivBody={() =>
                                    <div className="timesheet-info d-flex align-items-center justify-content-between flex-wrap">
                                        <div className="intime d-flex align-items-center mt-2">
                                            <i className="icofont-finger-print fs-4 color-light-success"></i>
                                            <span className="fw-bold ms-1">Punch In : {data?.data?.today?.punchIn || "---"}</span>
                                        </div>
                                        {data?.data?.today?.punchOut &&
                                            <div className="outtime mt-2 w-sm-100">
                                                <span className="fw-bold ms-1">Punch Out : {data?.data?.today?.punchOut}</span>
                                            </div>}
                                    </div>
                                }
                                    identity="todaytimeutl"
                                    data={TodayTimeUtilisationData}
                                    footerBody={
                                        <div className="timesheet-info d-flex align-items-center justify-content-around flex-wrap">
                                            <div className="intime d-flex align-items-center">
                                                <i className="icofont-lunch fs-3 color-lavender-purple"></i>
                                                <span className="fw-bold ms-1">Break: {data?.data?.today?.break || "-"} </span>
                                            </div>
                                            <div className="intime d-flex align-items-center">
                                                <i className="icofont-ui-timer fs-4 color-light-success"></i>
                                                <span className="fw-bold ms-1">Overtime: {data?.data?.today?.overTime || "-"}</span>
                                            </div>
                                        </div>
                                    }
                                />
                            </div>
                            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-12">
                                <GeneralChartCard Title="Employess Yearly Status" identity="Employessyearlystatus" data={EmployessYearlyStatusData} />
                            </div>
                        </div>
                        <div className="row clearfix g-3 mb-3">
                            <div className="col-lg-12 col-md-12 flex-column">
                                <div className="row g-3 row-deck">
                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
                                        <StatisticsCard data={data?.data} />
                                    </div>
                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12">
                                        <RecentActivityCard data={data?.data} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row clearfix g-3">
                            <div className="col-sm-12">
                                <DataTable
                                    title={TimeAttandanceData.title}
                                    columns={columnST}
                                    data={data?.data?.overallAttendance}
                                    defaultSortField="title"
                                    pagination
                                    selectableRows={false}
                                    className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                    highlightOnHover={true}
                                />
                            </div>
                        </div>
                    </>}
                </>}
        </div>
    )
}


export default AttendanceEmployees;